import { AfterContentInit, Component, ContentChild, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccordionItemContentComponent } from 'src/app/shared/accordion/accordion-item-content/accordion-item-content.component';
import { AccordionItemHeadComponent } from 'src/app/shared/accordion/accordion-item-head/accordion-item-head.component';
import { AccordionService } from 'src/app/shared/accordion/accordion.service';

@Component({
  selector: 'app-accordion-item',
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss']
})
export class AccordionItemComponent implements OnInit, AfterContentInit, OnDestroy {
  @ContentChild(AccordionItemHeadComponent) head: AccordionItemHeadComponent;
  @ContentChild(AccordionItemContentComponent) content: AccordionItemContentComponent;
  @Input() id: string;
  @Input() private isShow = false;
  private $subscriptionHead: Subscription;

  constructor(
    private accordionService: AccordionService
  ) { }

  ngOnInit() {
  }

  ngAfterContentInit(): void {
    this.showAndHide();
    this.$subscriptionHead = this.head.clickHead.subscribe(isOpen => {
      this.isShow = isOpen;
      this.showAndHide();
    });
  }

  ngOnDestroy(): void {
    this.$subscriptionHead.unsubscribe();
  }

  hideContent() {
    this.isShow = false;
    this.head.hide();
    this.content.hide();
  }

  private showAndHide() {
    if (this.isShow) {
      this.head.show();
      this.content.show();
      this.accordionService.open(this.id);
    } else {
      this.head.hide();
      this.content.hide();
      this.accordionService.close();
    }
  }
}
